export const API_URL = process.env.REACT_APP_API_URL || 'https://localhost';
export const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || 'refine-token';
export const PERMISSIONS_KEY = process.env.REACT_APP_PERMISSIONS_KEY || 'refine-permissions';